export const MODULE_NAME = 'logs';

export const LOGS = 'logs';
export const SET_LOGS = 'setLogs';
export const USERS_LOGS = 'usersLogs';
export const LOADING_LOGS = 'loadingLogs';

export const SET_USERS_LOGS = 'setUsersLogs';
export const SECUREVUE_TRANSACTIONS = 'securevueTransactions';
export const SET_SECUREVUE_TRANSACTIONS = 'setSecurevueTransactions';
